<div class="flex flex-col flex-1 p-4">
  <p class="font-semibold text-2xl">Vos tâches</p>
  <div class="flex gap-2 items-center pb-4 select-none">
    <span
      class="text-md text-gray-300"
      (click)="switchNotification('today')"
      [ngClass]="{ 'text-primary': selectedNotification() === 'today' }"
    >
      Aujourd'hui
      <span class="badge badge-primary badge-xs rounded-2xl items-center">{{
        notifications$().length
      }}</span>
    </span>
    <div class="h-4 w-0.5 bg-[#D7D7D7]"></div>
    <span
      class="text-md text-gray-300"
      (click)="switchNotification('next')"
      [ngClass]="{ 'text-primary': selectedNotification() === 'next' }"
    >
      A venir
    </span>
    <span
      class="text-md text-gray-300"
      (click)="switchNotification('done')"
      [ngClass]="{ 'text-primary': selectedNotification() === 'done' }"
    >
      Terminé
    </span>
  </div>
  <div class="flex flex-col gap-2">
    @for (notification of notifications$(); track notification._id) {
      <div
        [routerLink]="['/forms', notification.payload.form]"
        [queryParams]="{ notification_id: notification._id }"
        (click)="resetForm()"
        class="flex flex-row bg-white rounded-xl border-l-primary border-l-6 justify-between items-center p-2"
      >
        <div class="flex flex-col">
          <div class="">
            <div class="flex flex-row items-center gap-2">
              <span class="badge badge-sm badge-outline badge-primary">
                {{ notification.payload?.formData?.name || 'Erreur formulaire' }}
              </span>
              <span class="font-bold">
                @if(notification.payload?.employee?.name) {
                  {{ notification.payload?.employee?.name }}
                } @else {
                  {{ notification.employee?.firstname || notification.payload?.employee?.name || '' }}
                  {{ notification.employee?.lastname || notification.payload?.employees.find(e => e.selected)?.name || '' }}
                }
              </span>
            </div>
            <div class="text-gray-400 text-sm flex flex-row gap-2">
              <span>{{ notification.dueDate | date: 'dd/MM/yyyy' }}</span>
              <span>|</span>
              <span>{{
                notification.client?.name || notification.payload?.client?.name || ''
              }}</span>
            </div>
          </div>
        </div>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              fill="currentColor"
              d="M8.025 22L6.25 20.225L14.475 12L6.25 3.775L8.025 2l10 10z"
            />
          </svg>
        </div>
      </div>
    }
  </div>
</div>
